import React, { createContext, useContext, useState, useCallback } from 'react';
import en from './en';
import vi from './vi';

const translations = { en, vi };
const LanguageContext = createContext(null);

export function useLanguage() {
  return useContext(LanguageContext);
}

export function useTranslation() {
  const { lang } = useContext(LanguageContext);
  const t = useCallback((key, params) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      if (val == null) break;
      val = val[k];
    }
    if (val == null) {
      // Fallback to English
      let fallback = translations.en;
      for (const k of keys) {
        if (fallback == null) break;
        fallback = fallback[k];
      }
      val = fallback;
    }
    if (val == null) return key;
    if (typeof val === 'string' && params) {
      return val.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? `{${k}}`);
    }
    return val;
  }, [lang]);
  return { t, lang };
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('sustek_lang') || 'en';
  });

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('sustek_lang', newLang);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang: switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
}
